import { sendEloquaData } from './graphQlSvc';

const EloquaActions = {
    SET_ELOQUACOMPETITORLINKCAPTURE_START: 'SET_ELOQUACOMPETITORLINKCAPTURE_START',
    SET_ELOQUACOMPETITORLINKCAPTURE_SUCCESS: 'SET_ELOQUACOMPETITORLINKCAPTURE_SUCCESS',
    SET_ELOQUACOMPETITORLINKCAPTURE_FAIL: 'SET_ELOQUACOMPETITORLINKCAPTURE_FAIL',

    SET_ELOQUACOMPETITORLINKCAPTURE_VALUE: 'SET_ELOQUACOMPETITORLINKCAPTURE_VALUE',

    CLEAR_ELOQUACOMPETITORLINKCAPTURE_DATA: 'CLEAR_ELOQUACOMPETITORLINKCAPTURE_DATA',

    setEloquaCompetitorLinkCaptureValue: (value) => ({
        type: EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_VALUE,
        value,
        persist: true
    }),

    clearEloquaCompetitorLinkCaptureData: () => ({
        type: EloquaActions.CLEAR_ELOQUACOMPETITORLINKCAPTURE_DATA,
        persist: true
    }),

    sendEloquaCompetitorLinkCapture: (data) => {
        const start = () => ({ type: EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_START });
        const success = (eloquaReponseData) => {
            if (eloquaReponseData.statusCode === 200) {
                return ({
                    type: EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_SUCCESS
                });
            }
            return ({ type: EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_FAIL });
        };
        const fail = () => ({ type: EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_FAIL });
        return sendEloquaData(data, start, success, fail);
    }
};

export default EloquaActions;
